import { render, staticRenderFns } from "./GoBeyondSection.vue?vue&type=template&id=564c6cbf&scoped=true"
import script from "./GoBeyondSection.vue?vue&type=script&lang=js"
export * from "./GoBeyondSection.vue?vue&type=script&lang=js"
import style0 from "./GoBeyondSection.vue?vue&type=style&index=0&id=564c6cbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564c6cbf",
  null
  
)

export default component.exports